// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

let mermaidReady

export const onRouteUpdate = () => {
  // Mermaid
  const nodes = document.querySelectorAll("pre.mermaid")
  if (nodes.length > 0) {
    if (!mermaidReady) {
      mermaidReady = import("mermaid").then(({ default: mermaid }) => {
        mermaid.initialize({ startOnLoad: false })
        return mermaid
      })
    }
    mermaidReady
      .then(mermaid => mermaid.run({ nodes }))
      .then(() => initMermaidZoom())
  }

  // Image zoom
  initImageZoom()
}

function initImageZoom() {
  const images = document.querySelectorAll("#md img")
  if (images.length === 0) return

  images.forEach(img => {
    if (img.dataset.zoomBound) return
    img.dataset.zoomBound = "true"
    img.style.cursor = "zoom-in"
    img.addEventListener("click", (e) => {
      e.preventDefault()
      e.stopPropagation()
      // gatsby-remark-images wraps img in <a> with full-size href
      const parentLink = img.closest("a")
      const fullSrc = parentLink ? parentLink.href : img.src
      openZoom(fullSrc)
    })
  })
}

function initMermaidZoom() {
  const diagrams = document.querySelectorAll("pre.mermaid[data-processed='true']")
  diagrams.forEach(pre => {
    if (pre.dataset.zoomBound) return
    pre.dataset.zoomBound = "true"
    pre.style.cursor = "zoom-in"
    pre.addEventListener("click", (e) => {
      e.preventDefault()
      const svg = pre.querySelector("svg")
      if (!svg) return
      const svgData = new XMLSerializer().serializeToString(svg)
      const dataUrl = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgData)
      openZoom(dataUrl, { svg: true })
    })
  })
}

function openZoom(src, opts = {}) {
  const isSvg = opts.svg || false
  const overlay = document.createElement("div")
  Object.assign(overlay.style, {
    position: "fixed",
    inset: "0",
    background: isSvg ? "rgba(255,255,255,0.95)" : "rgba(0,0,0,0.8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: "9999",
    cursor: "zoom-out",
    opacity: "0",
    transition: "opacity 0.25s ease",
  })

  const clone = document.createElement("img")
  clone.src = src
  Object.assign(clone.style, {
    maxWidth: "90vw",
    maxHeight: "90vh",
    objectFit: "contain",
    borderRadius: "4px",
    transform: "scale(0.95)",
    transition: "transform 0.25s ease",
  })

  overlay.appendChild(clone)
  document.body.appendChild(overlay)

  requestAnimationFrame(() => {
    overlay.style.opacity = "1"
    clone.style.transform = "scale(1)"
  })

  const onKey = (e) => {
    if (e.key === "Escape") {
      close()
    }
  }

  const close = () => {
    overlay.style.opacity = "0"
    clone.style.transform = "scale(0.95)"
    document.removeEventListener("keydown", onKey)
    overlay.addEventListener("transitionend", () => overlay.remove(), { once: true })
  }

  overlay.addEventListener("click", close)
  document.addEventListener("keydown", onKey)
}
